<template>
  <div class="v-atlas-standard-module-details">
    <p>
      Zu diesem Modul gibt es keine Detailinformationen oder Einstellungsmöglichkeiten.
    </p>
  </div>
</template>

<script setup lang="ts">
import { ViewStackController } from 'gertrud';


const props = withDefaults(defineProps<{
  options?: any
  settings?: any
  viewStackController: ViewStackController
}>(), {
  options: () => ({}),
  settings: () => ({})
})


</script>
